var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.data
    ? _c("div", [
        _c(
          "div",
          { staticClass: "p-3 text-center" },
          _vm._l(_setup.years, function (year) {
            return _c(
              _setup.Button,
              {
                key: year,
                attrs: { "active-value": _setup.selectedYear === year },
                nativeOn: {
                  click: function ($event) {
                    return _setup.setYear(year)
                  },
                },
              },
              [_vm._v("\n                " + _vm._s(year) + "\n            ")]
            )
          }),
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-body" }, [
            _c(
              "table",
              { staticClass: "table table-condensed table-striped" },
              [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_setup.monthNames, function (monthName, i) {
                    return _c(
                      "tr",
                      { key: i },
                      [
                        _setup.monthTotals
                          ? [
                              _c("td", [
                                _setup.monthTotals[i]
                                  ? _c(
                                      "a",
                                      {
                                        attrs: { href: "" },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _setup.showMonth(i)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(monthName) +
                                            "\n                            "
                                        ),
                                      ]
                                    )
                                  : _c("span", [_vm._v(_vm._s(monthName))]),
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-end" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_setup.monthTotals[i]?.orders || 0) +
                                    "\n                        "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-end" }, [
                                _vm._v(
                                  "\n                            £" +
                                    _vm._s(
                                      _setup.numberFormat(
                                        _setup.monthTotals[i]?.net || 0
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-end" }, [
                                _vm._v(
                                  "\n                            £" +
                                    _vm._s(
                                      _setup.numberFormat(
                                        _setup.monthTotals[i]?.tax || 0
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-end" }, [
                                _vm._v(
                                  "\n                            £" +
                                    _vm._s(
                                      _setup.numberFormat(
                                        _setup.monthTotals[i]?.gross || 0
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-end" }, [
                                _vm._v(
                                  "\n                            £" +
                                    _vm._s(
                                      _setup.numberFormat(
                                        _setup.monthTotals[i]?.shipping || 0
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-end" }, [
                                _vm._v(
                                  "\n                            £" +
                                    _vm._s(
                                      _setup.numberFormat(
                                        _setup.monthTotals[i]?.total || 0
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ]),
                            ]
                          : _vm._e(),
                      ],
                      2
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _setup.yearTotals
                  ? _c("tfoot", [
                      _c("tr", [
                        _c("th", [_vm._v("Total")]),
                        _vm._v(" "),
                        _c("th", { staticClass: "text-end" }, [
                          _vm._v(_vm._s(_setup.yearTotals.orders)),
                        ]),
                        _vm._v(" "),
                        _c("th", { staticClass: "text-end" }, [
                          _vm._v(
                            "£" +
                              _vm._s(_setup.numberFormat(_setup.yearTotals.net))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("th", { staticClass: "text-end" }, [
                          _vm._v(
                            "£" +
                              _vm._s(_setup.numberFormat(_setup.yearTotals.tax))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("th", { staticClass: "text-end" }, [
                          _vm._v(
                            "£" +
                              _vm._s(
                                _setup.numberFormat(_setup.yearTotals.gross)
                              )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("th", { staticClass: "text-end" }, [
                          _vm._v(
                            "£" +
                              _vm._s(
                                _setup.numberFormat(_setup.yearTotals.shipping)
                              )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("th", { staticClass: "text-end" }, [
                          _vm._v(
                            "£" +
                              _vm._s(
                                _setup.numberFormat(_setup.yearTotals.total)
                              )
                          ),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
              ]
            ),
          ]),
        ]),
      ])
    : _c("div", { staticClass: "p-5 text-center" }, [
        _c("div", {
          staticClass: "spinner-border text-primary",
          attrs: { role: "status" },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "mt-2 text-muted" }, [
          _vm._v("Loading sales data..."),
        ]),
      ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Month")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-end" }, [_vm._v("Orders")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-end" }, [_vm._v("Net")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-end" }, [_vm._v("VAT")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-end" }, [_vm._v("Gross")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-end" }, [_vm._v("Shipping")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-end" }, [_vm._v("Total")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }